import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import styles from './field.css'

const Field = ({ name, description, children }) => (
  <Relayout styleName="field">
    <RelayoutItem md="5" sm="12">
      <h2 styleName="label">{name}</h2>
      {description &&
        <p styleName="description">{description}</p>
      }
    </RelayoutItem>
    <RelayoutItem md="7" sm="12">
      <div styleName="children">
        {children}
      </div>
    </RelayoutItem>
  </Relayout>
)


Field.propTypes = {
  children: PropTypes.any,
  description: PropTypes.string,
  name: PropTypes.string.isRequired,
}

export default CSSModules(Field, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/field.js
 **/